var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconidea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2409_34653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.87451C7.74112 1.87451 7.53125 2.08439 7.53125 2.34326C7.53125 2.60214 7.74112 2.81201 8 2.81201C9.55106 2.81201 10.813 4.0737 10.813 5.62451C10.813 5.88339 11.0228 6.09326 11.2817 6.09326C11.5406 6.09326 11.7505 5.88339 11.7505 5.62451C11.7505 3.55676 10.068 1.87451 8 1.87451Z",
    fill: "url(#paint0_linear_2409_34653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79142 0.126056C4.67361 0.568588 2.95642 2.26934 2.50457 4.40031C2.12304 6.19974 2.5932 8.00631 3.79448 9.35678C4.3817 10.0169 4.71845 10.8882 4.71845 11.7498V12.6873C4.71845 13.3111 5.12679 13.841 5.69011 14.0245C5.87536 15.119 6.82536 15.9998 7.9997 15.9998C9.17373 15.9998 10.124 15.1193 10.3093 14.0245C10.8726 13.841 11.281 13.3111 11.281 12.6873V11.7498C11.281 10.8865 11.6188 10.0256 12.2323 9.32575C13.1302 8.30137 13.6247 6.98699 13.6247 5.62481C13.6247 2.0759 10.3763 -0.622881 6.79142 0.126056ZM7.9997 15.0623C7.39714 15.0623 6.86882 14.6477 6.67373 14.0904H9.32564C9.13057 14.6477 8.60226 15.0623 7.9997 15.0623ZM10.3435 12.6873C10.3435 12.9458 10.1332 13.1561 9.8747 13.1561H6.1247C5.86623 13.1561 5.65595 12.9458 5.65595 12.6873V12.2186H10.3435V12.6873ZM11.5273 8.70784C10.8735 9.45368 10.4713 10.3531 10.3692 11.2811H5.63026C5.52832 10.3526 5.12714 9.44434 4.49501 8.73368C3.49382 7.60818 3.10261 6.09959 3.4217 4.59478C3.79417 2.83809 5.22542 1.41106 6.9832 1.04378C9.98395 0.416681 12.6872 2.67018 12.6872 5.62481C12.6872 6.75956 12.2753 7.85446 11.5273 8.70784Z",
    fill: "url(#paint1_linear_2409_34653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40625 5.62451H0.46875C0.209875 5.62451 0 5.83439 0 6.09326C0 6.35214 0.209875 6.56201 0.46875 6.56201H1.40625C1.66513 6.56201 1.875 6.35214 1.875 6.09326C1.875 5.83439 1.66513 5.62451 1.40625 5.62451Z",
    fill: "url(#paint2_linear_2409_34653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59983 3.28116L0.936922 2.61825C0.753891 2.43519 0.457078 2.43519 0.274016 2.61825C0.0909531 2.80132 0.0909531 3.0981 0.274016 3.28116L0.936922 3.94407C1.11995 4.12713 1.41677 4.12716 1.59983 3.94407C1.78289 3.761 1.78289 3.46422 1.59983 3.28116Z",
    fill: "url(#paint3_linear_2409_34653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59983 8.24325C1.41677 8.06019 1.11995 8.06019 0.936922 8.24325L0.274016 8.90616C0.0909531 9.08922 0.0909531 9.386 0.274016 9.56907C0.457047 9.75213 0.753859 9.75216 0.936922 9.56907L1.59983 8.90616C1.78289 8.7231 1.78289 8.42632 1.59983 8.24325Z",
    fill: "url(#paint4_linear_2409_34653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 5.62451H14.5938C14.3349 5.62451 14.125 5.83439 14.125 6.09326C14.125 6.35214 14.3349 6.56201 14.5938 6.56201H15.5312C15.7901 6.56201 16 6.35214 16 6.09326C16 5.83439 15.7901 5.62451 15.5312 5.62451Z",
    fill: "url(#paint5_linear_2409_34653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7248 2.61825C15.5418 2.43519 15.245 2.43519 15.0619 2.61825L14.399 3.28116C14.216 3.46422 14.216 3.761 14.399 3.94407C14.582 4.1271 14.8789 4.12713 15.0619 3.94407L15.7248 3.28116C15.9079 3.0981 15.9079 2.80132 15.7248 2.61825Z",
    fill: "url(#paint6_linear_2409_34653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7248 8.90616L15.0619 8.24325C14.8789 8.06019 14.5821 8.06019 14.399 8.24325C14.216 8.42632 14.216 8.7231 14.399 8.90616L15.0619 9.56907C15.245 9.7521 15.5418 9.75213 15.7248 9.56907C15.9079 9.386 15.9079 9.08922 15.7248 8.90616Z",
    fill: "url(#paint7_linear_2409_34653)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2409_34653",
    x1: 11.764,
    y1: 7.33523,
    x2: 6.3646,
    y2: 5.45009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2409_34653",
    x1: 13.6609,
    y1: 20.7099,
    x2: -1.57266,
    y2: 16.9706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2409_34653",
    x1: 1.88103,
    y1: 6.83801,
    x2: 0.0712726,
    y2: 5.57444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2409_34653",
    x1: 1.74227,
    y1: 4.55253,
    x2: -0.30586,
    y2: 3.83754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2409_34653",
    x1: 1.74227,
    y1: 10.1775,
    x2: -0.30586,
    y2: 9.46253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2409_34653",
    x1: 16.006,
    y1: 6.83801,
    x2: 14.1963,
    y2: 5.57444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2409_34653",
    x1: 15.8673,
    y1: 4.5525,
    x2: 13.8191,
    y2: 3.8375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2409_34653",
    x1: 15.8673,
    y1: 10.1775,
    x2: 13.8191,
    y2: 9.46249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2409_34653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconidea);
export default __webpack_public_path__ + "static/media/iconidea.b8612581b5a3529ae4ff9c52221e2cf8.svg";
export { ForwardRef as ReactComponent };